import client from "./client";

const settlementReportAPI = {
  getRecords: async () => {
    const res = await client.get("/settlement-reports/records");
    return res.data;
  },

  getReturnsInTransit: async () => {
    const res = await client.get("/settlement-reports/returns-in-transit");
    return res.data;
  },

  getUploads: async () => {
    const res = await client.get("/settlement-reports/uploads");
    return res.data;
  },

  getSellerNames: async () => {
    const res = await client.get("/settlement-reports/seller-names");
    return res.data;
  },

  getStatusHistory: async (reportType = "ALL") => {
    const res = await client.get("/settlement-reports/status-history", { params: { reportType } });
    return res.data;
  },

  getSkuManagement: async () => {
    const res = await client.get("/settlement-reports/sku-management");
    return res.data;
  },

  getDifference: async (date) => {
    const res = await client.get("/settlement-reports/difference", { params: { date } });
    return res.data;
  },

  getThreeReportDifference: async () => {
    const res = await client.get("/settlement-reports/three-report-difference");
    return res.data;
  },

  assignSkus: async (payload) => {
    const res = await client.post("/settlement-reports/sku-management/assign", payload);
    return res.data;
  },

  deleteSkuMapping: async (id) => {
    const res = await client.delete(`/settlement-reports/sku-management/${id}`);
    return res.data;
  },

  uploadPrimary: async (payload) => {
    const res = await client.post("/settlement-reports/upload-primary", payload);
    return res.data;
  },

  uploadTracking: async (payload) => {
    const res = await client.post("/settlement-reports/upload-tracking", payload);
    return res.data;
  },

  uploadSecondary: async (payload) => {
    const res = await client.post("/settlement-reports/upload-secondary", payload);
    return res.data;
  },

  updateRecord: async (id, payload) => {
    const res = await client.put(`/settlement-reports/records/${id}`, payload);
    return res.data;
  },

  deleteRecord: async (id) => {
    const res = await client.delete(`/settlement-reports/records/${id}`);
    return res.data;
  },

  updateUpload: async (id, payload) => {
    const res = await client.put(`/settlement-reports/uploads/${id}`, payload);
    return res.data;
  },

  deleteUpload: async (id) => {
    const res = await client.delete(`/settlement-reports/uploads/${id}`);
    return res.data;
  },
};

export default settlementReportAPI;
